module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox) {
	fox.registerWidget('Navigator', {
		configure: function() {
			this.registerOptions('', {
				hashStart: '#!/',
				updatePeriod: 100,
				basePath: '/',
				type: 'href',
				skipHandlePatterns: {
					api: ['path', '~', new RegExp('^\/api\/')],
					jsmail: ['href', '~', new RegExp('^(javascript\:|mailto\:)')],
					absolute: ['href', '~', new RegExp('^https?:\/\/')],
					hash: ['href', '=', '#']
				}
			});

			if (!fox.Navigator) {
				Object.defineProperty(fox, 'Navigator', {
					get: fox.bind(function() {return this._wom.getRoot().rwom1(this._wom.getRoot().getOption('naviPath') || '#navi');}, this)
				});
			}

			this.pages = [];
			this.callParent('configure', arguments);

			this.clickListener = function (e) {
				return this.clickHandler.call(this, e.currentTarget, e);
			}.bind(this);
		},

		addClickHandler: function(fragment, options) {
      options = options || {};

      var selector = options.selector || 'a';
      
			fox.each(fox.dom.select(selector, fragment), function(node) {
				if (fox.isSet((options || {}).draggable)) {
					node.setAttribute('draggable', options.draggable);
				}

				var href = node.getAttribute('href');
				if (!this.shouldProcessHref(href)) {
					return;
				}

				fox.dom.off('click', node, this.clickListener);
				fox.dom.on('click', node, this.clickListener);

				if (href.indexOf(this.urlPrefix) === 0) {
					return;
				}
				
				var arr = href.split(this.hashStart);
				if (arr[1]) {
					href = this.urlPrefix + arr[1];
				} else {
					href = this.urlPrefix + fox.trim(href, '/');
				}

				node.setAttribute('href', href);

			}, this);
		},

		init: function() {
			this.setOption('type', this.getOption('navigation.type') || this.getOption('type'));
			this.setOption('basePath', this.getOption('navigation.basePath') || this.getOption('basePath'));
			this.location = null;
			this.virtualLocation = '';
			this.objHash = false;
			this.hashStart = this.getOption('hashStart');
			this.typedAction('init');
			this.process();
			this.callParent('init', arguments);
			if (window.snListen) {
				window.removeEventListener('click', window.snListen);
				window.snHref && this.processHref(window.snHref);
			}
		},

		start: function() {

		},

		setPages: function(pages) {
			this.pages = pages;
		},

		shouldProcessHref: function(href) {
			if (!href) {
				return false;
			}
			var parts = this.parseUrl(href), res = true;
			fox.each(this.getOption('skipHandlePatterns'), function(info, alias) {
				switch (info[1]) {
					case '~':
						res = res && !info[2].exec(parts[info[0]]);
					break;
					case '=':
						res = res && (parts[info[0]] !== info[2]);
					break;
				}
			}, this);

			return res;
		},

		clickHandler: function(node, e) {
			if (node.getAttribute('target')) return true;

			e.preventDefault();
			var href = node.getAttribute('href');
			this.processHref(href);
			return false;
		},

		processHref: function(href) {
			if (!this.shouldProcessHref(href)) {
				return false;
			}

			this.typedAction('clickHandler', href);
			return true;
		},

		hash2obj: function(hash) {
			if (fox.isEmpty(hash)) {
				return {};
			}
			var arr = fox.trim(hash, '/').split('/'), obj = {}, index = 0;
			fox.each(arr, function(value, i) {
				var arr = value.split('=');
				if (arr.length > 1) {
					i = arr.shift();
					value = arr.join('=');
				} else {
					i = index++;
				}
				obj[i] = value;
			});
			return obj;
		},

		obj2hash: function(obj) {
			var hash = [];
			obj = fox.clone(obj);
			fox.each(obj, function(val, name) {
				if (fox.isNumeric(name)) {
					if (val !== undefined) {
						hash.push(val);
						delete obj[name];
					}
				}
			});

			fox.each(obj, function(val, name) {
				if (val !== undefined) {
					hash.push(name + '=' + val);
				}
			});

			return hash.join('/');
		},

		getDiff: function(oldObj, newObj) {
			var diff = {};
			fox.each(oldObj, function(val, name) {
				if (typeof newObj[name] == 'undefined') {
					diff[name] = 'deleted';
				} else if (newObj[name] != oldObj[name]) {
					diff[name] = 'changed';
				}
			});

			fox.each(newObj, function(val, name) {
				if (typeof oldObj[name] == 'undefined') {
					diff[name] = 'added';
				}
			});

			return diff;
		},

		reset: function() {
			this.location = null;
			this.virtualLocation = '';
			this.objHash = {};
		},

		process: function() {
			if (this.typedAction('checkUpdated')) {
				if (this.getOption('type') != 'virtual') {
					var parsedUrl = this.parseUrl(location.href);
					if ((parsedUrl.pathname + parsedUrl.search).indexOf(this.getOption('basePath')) !== 0) {
						return;
					}
				}
				var page = this.typedAction('preprocessHref');
				if (page === false) {
					return;
				}

				var newObj = this.hash2obj(page);
				var diff = (!this.objHash && fox.isEmpty(newObj)) ? { 0: '' } : this.getDiff(this.objHash, newObj);
				this.location = page;
				this.objHash = newObj;

				fox.each(diff, function(val, name) {
					this.dispatchEvent(val + '_' + name, this.get(name));
					this.dispatchEvent('modified_' + name, this.get(name));
				}, this);

				if (!fox.isEmpty(diff)) {
					this.dispatchEvent('modified', diff);
				}
			}
			return this;
		},

		parseUrl: function(url) {
			var pattern = "^(([^:/\\?#]+):)?(//(([^:/\\?#]*)(?::([^/\\?#]*))?))?([^\\?#]*)(\\?([^#]*))?(#(.*))?$";
			var rx = new RegExp(pattern);
			var parts = rx.exec(url);

			var res = {};
			res.href = parts[0] || "";
			res.protocol = parts[1] || "";
			res.host = parts[4] || "";
			res.hostname = parts[5] || "";
			res.port = parts[6] || "";
			res.pathname = parts[7] || "/";
			res.search = parts[8] || "";
			res.hash = parts[10] || "";
			res.path = res.pathname;
			return res;
		},

		parseSearch: function(str) {
			if (fox.isEmpty(str)) {
				str = location.search;
			}

			str = str.indexOf('?') === 0 ? str.substr(1) : str;
			var res = {}, data = str.split('&');
			fox.each(data, function(val) {
				var tmp = val.split('=', 2);
				res[tmp[0]] = tmp[1];
			});

			return res;
		},

		get: function(name) {
			if (this.objHash[name]) {
				return this.objHash[name];
			}
			return false;
		},

		getAll: function() {
			return fox.clone(this.objHash, true);
		},

		bulkSet: function(values, skipEvent) {
			var objHash = fox.clone(this.objHash, true);
			fox.each(values, function(value, name){
				objHash[name] = value;
			});
			return this.update(objHash, skipEvent);
		},

		set: function(name, val, skipEvent) {
			var objHash = fox.clone(this.objHash, true);
			objHash[name] = val;
			return this.update(objHash, skipEvent);
		},

		update: function(obj, skipEvent) {
			var newLocation = this.urlPrefix +  this.obj2hash(obj);

			if (skipEvent && skipEvent < 2) {
				this.location = newLocation;
				this.objHash = obj;
			}

			this.typedAction('update', newLocation, skipEvent);
			return this;
		},

		typedAction: function(action) {
			switch (action) {
				case 'init':
					this.useHash = false;
					switch (this.getOption('type')) {
						case 'hash':
							this.urlPrefix = this.getOption('basePath') + this.hashStart;
							this.useHash = true;
							fox.dom.on('hashchange', this._wom.getRoot().window, fox.bind(this.process, this));
							//setInterval(fox.bind(this.process, this), 100);
						break;
						case 'href':
							this.urlPrefix = this.getOption('basePath');
							fox.dom.on('popstate', this._wom.getRoot().window, fox.bind(this.process, this));
							this.addClickHandler(this._wom.getRoot().window.document);
						break;
						case 'virtual':
							this.urlPrefix = '/';
						break;
					}
					if (this.urlPrefix[this.urlPrefix.length - 1] != '/') {
						this.urlPrefix = this.urlPrefix + '/';
					}
					return;
				break;
				case 'checkUpdated':
					switch (this.getOption('type')) {
						case 'hash':
							var source = location.href;
						break;
						case 'href':
							var source = location.href.replace(location.hash, '')
						break;
						case 'virtual':
							var source = this.virtualLocation;
						break;
					}
					return this.location !== this.typedAction('preprocessHref');
				break;
				case 'preprocessHref':
					switch (this.getOption('type')) {
						case 'href':
							if (~location.href.indexOf(this.hashStart)) {
								var arr = location.href.split(this.hashStart);
								history.replaceState(null, document.title, this.urlPrefix + arr[1]);
							}
							var page = this.parseUrl(location.href).pathname;
						break;
						case 'hash':
							if (~location.href.indexOf(this.hashStart)) {
								var page = this.parseUrl(location.href).hash.substring(this.hashStart.length - 1);
							} else {
								return '';
							}
						break;
						case 'virtual':
							var page = this.virtualLocation;
						break;
					}
					return page.replace(new RegExp('^' + this.getOption('basePath')), '');
				break;
				case 'update':
					switch (this.getOption('type')) {
						case 'hash':
							location.href = arguments[1];
							return;
						break;
						case 'href':
							history[arguments[2] ? 'replaceState' : 'pushState'](null, null, arguments[1]);
						break;
						case 'virtual':
							this.virtualLocation = arguments[1];
						break;
					}
					return this.process();
				break;
				case 'clickHandler':
					switch (this.getOption('type')) {
						case 'href':
							history.pushState(null, null, arguments[1]);
						break;
						case 'hash':
							location.href = arguments[1];
							return;
						break;
						case 'virtual':
							this.virtualLocation = arguments[1];
						break;
					}
					this.process();
				break;


			}
		}

	}, 'Controller');

})(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-core-resource/lib/widgets/navigator.js
// module id = 215
// module chunks = 0